import { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "sonner";
import { api } from "@/lib/api";

const renderPdf = async (nodeId, filename) => {
  const node = document.getElementById(nodeId);
  const canvas = await html2canvas(node, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgH = (canvas.height * pageW) / canvas.width;
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(img, "PNG", 0, position, pageW, imgH);
  heightLeft -= pageH;
  while (heightLeft > 0) {
    position -= pageH;
    pdf.addPage();
    pdf.addImage(img, "PNG", 0, position, pageW, imgH);
    heightLeft -= pageH;
  }
  pdf.save(filename);
};

const printNode = (nodeId, title) =>
  new Promise((resolve) => {
    const node = document.getElementById(nodeId);
    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument;
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]')).map((el) => el.outerHTML).join("");
    doc.open();
    doc.write(`<!doctype html><html><head><title>${title}</title>${styles}
      <style>@page{margin:12mm} html,body{background:#fff;margin:0} body{padding:0}</style></head>
      <body>${node.outerHTML}</body></html>`);
    doc.close();
    const finish = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => { document.body.removeChild(iframe); resolve(); }, 1000);
    };
    const imgs = Array.from(doc.images);
    if (!imgs.length) return setTimeout(finish, 150);
    let left = imgs.length;
    const done = () => { if (--left === 0) finish(); };
    imgs.forEach((img) => (img.complete ? done() : (img.onload = img.onerror = done)));
  });

export const useReceiptActions = (appointment, nodeId) => {
  const [downloading, setDownloading] = useState(false);
  const logEvent = (kind) => api.post(`/appointments/${appointment.id}/receipt-event`, { kind }).catch(() => {});

  const print = () => { logEvent("printed"); printNode(nodeId, `Receipt ${appointment.receipt_no}`); };

  const download = async () => {
    setDownloading(true);
    logEvent("downloaded");
    try { await renderPdf(nodeId, `${appointment.receipt_no}.pdf`); }
    catch { toast.error("Could not generate PDF"); }
    finally { setDownloading(false); }
  };

  return { downloading, print, download };
};
